import { render, staticRenderFns } from "./if.vue?vue&type=template&id=364ffa21"
import script from "./if.vue?vue&type=script&lang=js"
export * from "./if.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports